import React from 'react';
import { FileThumbPdfIcon as FileThumbPdfIconSrc } from 'src/assets/Images';
import { FilesContainer, FileThumb, FileThumbImage, FileThumbIcon } from './styles';
export var FileDisplay = function (_a) {
    var files = _a.files, filesContainerStyle = _a.filesContainerStyle, fileThumbStyle = _a.fileThumbStyle;
    if (!Array.isArray(files) || files.length === 0) {
        return null;
    }
    return (React.createElement(FilesContainer, { style: filesContainerStyle }, files.map(function (f) {
        var isImage = /\.(png|jpe?g|gif|webp)$/i.test(f.name);
        return (React.createElement(FileThumb, { key: f.id, href: f.url, target: "_blank", rel: "noopener noreferrer", title: f.name, style: fileThumbStyle }, isImage ? (React.createElement(FileThumbImage, { src: f.url, alt: f.name })) : (React.createElement(FileThumbIcon, { src: FileThumbPdfIconSrc, alt: "PDF" }))));
    })));
};
